import CONFIG from "../../config";

const actions = {
  sessionCreate(context, params) {
    context.commit("ADD_LOG", { request: "sessionCreate" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("sessionCreate"), params, {})
        .then(response => {
          context.commit("CREATE_SESSION", response.data);
          context.commit("REMOVE_LOG", { request: "sessionCreate" });
          resolve(response.data);
        })
        .catch(err => {
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
          context.commit("REMOVE_LOG", { request: "sessionCreate" });
        });
    });
  },
  referralStart(context, params) {
    context.commit("ADD_LOG", { request: "referralStart" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("referralStart"), params, {})
        .then(response => {
          context.commit("CREATE_SESSION", response.data);
          context.commit("REMOVE_LOG", { request: "referralStart" });
          resolve(response.data);
        })
        .catch(err => {
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
          context.commit("REMOVE_LOG", { request: "referralStart" });
        });
    });
  },
  marketplaceLogoUrl(context, params) {
    context.commit("ADD_LOG", { request: "marketplaceLogoUrl" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("marketplaceLogoUrl"), {
          params: params.queryParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "marketplaceLogoUrl" });
          context.commit("SAVE_MARKETPLACE_INFO", response.data);
          resolve(response.data);
        })
        .catch(err => {
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
          context.commit("REMOVE_LOG", { request: "marketplaceLogoUrl" });
        });
    });
  },
  customerLogin(context, params) {
    context.commit("ADD_LOG", { request: "customerLogin" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("customerLogin"), params, {})
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerLogin" });
          context.commit("SAVE_PHONE", params.phone);
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerLogin" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerPhoneBySession(context, params) {
    context.commit("ADD_LOG", { request: "customerPhoneBySession" });
    context.commit("CREATE_SESSION", params.queryParams);
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerPhoneBySession"), {
          params: params.queryParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerPhoneBySession" });
          context.commit("SAVE_PHONE", response.data.phone);
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerPhoneBySession" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  NewPhoneBySession(context, params) {
    context.commit("ADD_LOG", { request: "customerPhoneBySession" });
    context.commit("CREATE_SESSION", params.queryParams);
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerPhoneBySession"), {
          params: params.queryParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerPhoneBySession" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerPhoneBySession" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerLogout(context, origin) {
    context.commit("ADD_LOG", { request: "customerLogout" });
    return new Promise((resolve, reject) => {
      this.axios
        .delete(CONFIG.getEndpoint("customerLogout"), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          if (origin) {
            const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
            localStorage.setItem("newUrl", urlParams.origin);
          }
          context.commit("REMOVE_LOG", { request: "customerLogout" });
          context.commit("CLEAR_SESSION");
          resolve(response.data);
          if (localStorage.getItem("referralCallbackUrl")) {
            const logoutRedirectUrl = window.location.origin;
            window.location.href = logoutRedirectUrl;
          }
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerLogout" });
          context.commit("CLEAR_SESSION");
          reject(err);
          const logoutRedirectUrl = window.location.origin;
          window.location.href = logoutRedirectUrl;
        });
    });
  },
  customerLogoutGuarantor(context, origin) {
    if (origin) {
      const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
      localStorage.setItem("newUrl", urlParams.origin);
    }
    context.commit("REMOVE_LOG", { request: "customerLogout" });
    context.commit("CLEAR_SESSION");
  },
  customerOtp(context, params) {
    context.commit("ADD_LOG", { request: "customerOtp" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("customerOtp"), params, {})
        .then(response => {
          context.commit("SAVE_TOKEN", response.data);
          context.commit("PARSE_JWT", response.data.accessToken);
          context.commit("REMOVE_LOG", { request: "customerOtp" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerOtp" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerResendOtp(context, params) {
    context.commit("ADD_LOG", { request: "customerResendOtp" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("customerResendOtp"), params, {})
        .then(response => {
          context.commit("SAVE_TOKEN", response.data);
          context.commit("PARSE_JWT", response.data.accessToken);
          context.commit("REMOVE_LOG", { request: "customerResendOtp" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerResendOtp" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerServiceabilityCheck(context, params) {
    context.commit("ADD_LOG", { request: "customerServiceabilityCheck" });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint("customerServiceabilityCheck"), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerServiceabilityCheck" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerServiceabilityCheck" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerFaceVerification(context, params) {
    context.commit("ADD_LOG", { request: "customerFaceVerification" });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint("customerFaceVerification"), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerFaceVerification" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerFaceVerification" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerReferralCode(context, params) {
    context.commit("ADD_LOG", { request: "customerReferralCode" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerReferralCode", params.uuid), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerReferralCode" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerReferralCode" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerTransactionDetails(context, params) {
    context.commit("ADD_LOG", { request: "customerTransactionDetails" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerTransactionDetails", params.uuid), {
          params: params.urlParams,
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerTransactionDetails" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerTransactionDetails" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerLoyaltyPoint(context, params) {
    context.commit("ADD_LOG", { request: "customerLoyaltyPoint" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerLoyaltyPoint", params.uuid), {
          params: params.urlParams,
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerLoyaltyPoint" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerLoyaltyPoint" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  rewards(context) {
    context.commit("ADD_LOG", { request: "rewards" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("rewards"), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "rewards" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "rewards" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  rewardsById(context, params) {
    context.commit("ADD_LOG", { request: "rewardsById" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("rewardsById", params.id), {
          headers: {
            Authorization: localStorage.getItem("token")
          },
          params: params.urlParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "rewardsById" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "rewardsById" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerNbfcInfo(context, params) {
    context.commit("ADD_LOG", { request: "customerNbfcInfo" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerNbfcInfo", params.phone), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerNbfcInfo" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerNbfcInfo" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerTransactionPaymentMethod(context) {
    context.commit("ADD_LOG", { request: "customerTransactionPaymentMethod" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerTransactionPaymentMethod"), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerTransactionPaymentMethod" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerTransactionPaymentMethod" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  repaymentApplicationPaymentUrl(context, params) {
    context.commit("ADD_LOG", { request: "repaymentApplicationPaymentUrl" });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(
          CONFIG.getEndpoint("repaymentApplicationPaymentUrl", params.applicationId),
          params.patchParams,
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          context.commit("REMOVE_LOG", { request: "repaymentApplicationPaymentUrl" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "repaymentApplicationPaymentUrl" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  homeFlags(context) {
    context.commit('ADD_LOG', { request: 'homeFlags' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('homeFlags'), {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'homeFlags' });
          resolve(response.data);
          context.commit('FLAGS_DATA', response.data);
          context.commit('FLAGS_ALL_DATA', response.data);
          context.commit('RE_KYC_DATA', response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'homeFlags' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerBankName(context, params) {
    context.commit("ADD_LOG", { request: "customerBankName" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerBankName"), {
          headers: {
            Authorization: localStorage.getItem("token")
          },
          params: params.urlParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerBankName" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerBankName" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  customerBranchNameIfsc(context, params) {
    context.commit("ADD_LOG", { request: "customerBranchNameIfsc" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("customerBranchNameIfsc"), {
          headers: {
            Authorization: localStorage.getItem("token")
          },
          params: params.urlParams
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "customerBranchNameIfsc" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "customerBranchNameIfsc" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  generateStatement(context, params) {
    context.commit("ADD_LOG", { request: "generateStatement" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("generateStatement"), {
          headers: {
            Authorization: localStorage.getItem("token")
          },
          params: params.urlParams,
          responseType: 'blob',
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "generateStatement" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "generateStatement" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  initiateTransaction(context, params) {
    context.commit('ADD_LOG', { request: 'initiateTransaction' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('initiateTransaction'), params.rowData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'initiateTransaction' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'initiateTransaction' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  otherBanks(context, params) {
    context.commit('ADD_LOG', { request: 'otherBanks' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('otherBanks'), params.rowData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'otherBanks' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'otherBanks' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  processTransaction(context, params) {
    context.commit('ADD_LOG', { request: 'processTransaction' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('processTransaction'), params.rowData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'processTransaction' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'processTransaction' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  initPaytmSubscription(context, params) {
    context.commit('ADD_LOG', { request: 'initPaytmSubscription' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('initPaytmSubscription'), params.rowData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'initPaytmSubscription' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'initPaytmSubscription' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  registerPaytmMandate(context) {
    context.commit('ADD_LOG', { request: 'registerPaytmMandate' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('registerPaytmMandate'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'registerPaytmMandate' });
          resolve(response.data);
          context.commit('FLAGS_DATA', response.data);
          context.commit('FLAGS_ALL_DATA', response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'registerPaytmMandate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  RedirectPaytmPage(context, params) {
    context.commit("ADD_LOG", { request: "RedirectPaytmPage" });
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(params.formDetails.content);
      this.axios({
        method: params.formDetails.method,
        url: params.formDetails.actionUrl,
        data: formData,
        headers: params.formDetails.headers,
      })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "RedirectPaytmPage" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "RedirectPaytmPage" });
          reject(err);
        });
    });
  },
  notification(context) {
    context.commit("ADD_LOG", { request: "notification" });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint("notification"), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          context.commit("REMOVE_LOG", { request: "notification" });
          context.commit("NOTIFICATION_LIST", response.data);
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "notification" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  guarantorLogin(context, params) {
    context.commit("ADD_LOG", { request: "guarantorLogin" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("guarantorLogin"), params, {})
        .then(response => {
          context.commit("REMOVE_LOG", { request: "guarantorLogin" });
          context.commit("SAVE_PHONE", params.phoneNumber);
          context.commit('GUARANTOR_LOAN_ID', response.data.loanId);
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "guarantorLogin" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  guarantorVerifyOtp(context, params) {
    context.commit("ADD_LOG", { request: "guarantorVerifyOtp" });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint("guarantorVerifyOtp", params.loanId), params.postParams)
        .then(response => {
          context.commit("SAVE_TOKEN", response.data);
          context.commit("PARSE_JWT", response.data.accessToken);
          context.commit("REMOVE_LOG", { request: "guarantorVerifyOtp" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("REMOVE_LOG", { request: "guarantorVerifyOtp" });
          context.dispatch("resolveError", { err }).catch(resolvedError => {
            reject(resolvedError);
          });
        });
    });
  },
  guarantorSummary(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorSummary' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('guarantorSummary', params.loanId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorSummary' });
          context.commit("GUARANTOR_DATA", response.data);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorSummary' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  esignGuarantor(context, params) {
    context.commit('ADD_LOG', { request: 'esignGuarantor' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('esignGuarantor', params.loanId), params.rowData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'esignGuarantor' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'esignGuarantor' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
